import { generatePath } from 'quartz-routing/react-router';
import { PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT } from '../../constants/Navigation.legacy';
export const ASSIGNMENT_IDS_PARAM = 'assignmentIds';
export const CLOSE_DESTINATION_PARAM = 'closeDestination';
export const getPortalAssignmentsUrl = ({
  playlistId,
  documentFragmentLink = false
}) => {
  return `${generatePath(PLAYLIST_URL_FRAGMENT, {
    playlistId
  })}${documentFragmentLink ? '#playlist-assignments' : ''}`;
};
export const getAssignmentsForPortalUrl = ({
  portalId,
  playlistId,
  documentFragmentLink = false
}) => {
  return `${generatePath(PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, {
    portalId,
    playlistId
  })}${documentFragmentLink ? '#playlist-assignments' : ''}`;
};